import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';
import { useDispatch } from 'react-redux';
import { resetServices } from '../../../actions/backoffice/configuration';

export const ConfigurationHeader = ({ paymentState }) => {

	const dispatch = useDispatch();
	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="container-fluid">
			<nav className="navbar navbar-expand-sm navbar-light px-0 mb-2">
				<button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
					<span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
					<span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
				</button>
				<div className="collapse navbar-collapse flex-column" id="navbarNav">
					<ul className="nav nav-fill nav-pills bg-sm-dim rounded-max">
						<NavLink exact to="/backoffice/configuration" className="nav-item flex-sm-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1">General</div>
						</NavLink>
						<div className="w-100 mt-1 d-sm-none"></div>
						<NavLink exact to="/backoffice/configuration/services" onClick={() => dispatch(resetServices())} className="nav-item flex-sm-grow-1 text-uppercase rounded-inherit">
							<div className="nav-link py-1 px-0">Services</div>
						</NavLink>
					</ul>
				</div>
			</nav >
		</div >
	);
};